import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"
import FormGLAccount from "./Form"
import PropTypes from "prop-types"

class UpdateGLAccount extends React.Component {

  componentDidMount() {
    const { params, setCurrentId, loadData, glAccount } = this.props
    setCurrentId(params.id);
    if(!glAccount) {
      loadData()
    }
  }

  render() {
    const { glAccount } = this.props;
    return glAccount ? <FormGLAccount glAccount={ glAccount } /> : <p>Loading ..</p>
  }
}

UpdateGLAccount.propTypes = {
  glAccount: PropTypes.object,
  setCurrentId: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const glAccount = DckSelectors.selectItemById(state, ItemTypes.GLAccount, ownProps.params.id)
  return { glAccount }
}

const mapDispatchToProps = dispatch => ({
  setCurrentId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.GLAccount, id)),
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.GLAccount)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateGLAccount)



// WEBPACK FOOTER //
// ./src/components/Accounting/GLAccounts/Update.js